import { useEffect, useRef } from 'react';

/**
 * @param callback 바깥 클릭 시 호출될 콜백
 * @param enabled  document mousedown 리스너 부착 여부 (기본 true).
 *                 N개 인스턴스가 동시에 마운트되는 컴포넌트에서는 실제로 콜백이
 *                 유효한 순간에만 true로 넘겨, 비활성 인스턴스의 contains() 검사
 *                 비용을 0으로 만든다.
 */
export const useOutsideClick = (callback: () => void, enabled = true) => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!enabled) return;

    const handleClickOutside = (event: MouseEvent) => {
      const shouldCallback =
        ref.current && !ref.current.contains(event.target as Node);
      if (shouldCallback) {
        callback();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [callback, enabled]);

  return ref;
};
